const translations = {
  el: {
    meta: {
      title: 'Bioregano | Κατάλογος Προϊόντων',
      description:
        'Bioregano από τον Άγιο Πρόδρομο Χαλκιδικής. Φυσική, βιολογική, αρωματική ρίγανη.',
      keywords:
        'Ρίγανη,Bioregano ,Οικοτεχνία, Βιολογική καλλιέργεια, Χαλκιδική, Ελληνικά προϊόντα',
    },
    brand: 'bioregano',
    nav: {
      hero: 'Αρχική',
      intro: 'Εισαγωγή',
      products: 'Προϊόντα',
      delivery: 'Παράδοση',
      contact: 'Επικοινωνία',
    },
    hero: {
      title: 'Καλλιεργούμε με αγάπη την Ελληνική γη',
      cta: 'Μάθε περισσότερα',
    },
    intro: {
      title: 'Εισαγωγή',
      body:
        'Ονομάζομαι Μακαβού Μαγδαληνή και είμαι μικρή παραγωγός βιολογικών αρωματικών φυτών από την περιοχή του Αγίου Πρόδρομου, Χαλκιδικής. Ασχολούμαι με την καλλιέργεια και την παραγωγή υψηλής ποιότητας ρίγανης, θυμαριού, χαμομηλιού και τσαγιού του βουνού, 100% φυσικών και βιολογικών, συλλεγμένων με φροντίδα ώστε να διατηρούν τα αρώματα και τις ευεργετικές τους ιδιότητες.',
    },
    products: {
      title: 'Τα προϊόντα',
      body:
        'Επιλέγουμε και συσκευάζουμε με φροντίδα ρίγανη, θυμάρι, χαμομήλι και τσάι του βουνού, διατηρώντας στο ακέραιο το άρωμα, τη γεύση και τις ευεργετικές τους ιδιότητες. Διατίθενται σε διαφορετικές συσκευασίες και ποσότητες για να καλύψουν κάθε σας ανάγκη.',
      newLabel: 'Νέο',
      categoryEyebrow: 'Νέα κατηγορία',
      categoryTitle: 'Θυμάρι & χαμομήλι',
      categoryBody:
        'Προσθέτουμε μία ακόμη κατηγορία αρωματικών βοτάνων με διαλεγμένο θυμάρι και χαμομήλι, ιδανικά για μαγειρική, αφεψήματα και καθημερινή χρήση.',
      oregano: {
        eyebrow: 'Κατηγορία ρίγανης',
        marker: 'Ρ',
        title: 'Ρίγανη',
        text: 'Η βασική μας κατηγορία, διαθέσιμη σε διαφορετικές συσκευασίες για καθημερινή χρήση, λιανική και επαγγελματικές ανάγκες.',
        packaging1: {
          alt: 'Γυάλινο βαζάκι ρίγανης',
          title: 'Γυάλινο βαζάκι ρίγανης',
          text: 'Ιδανικό για καθημερινή χρήση και αποθήκευση, σε συσκευασία 50 γρ.',
        },
        packaging2: {
          alt: 'Συσκευασία kraft ρίγανης',
          title: 'Χάρτινη συσκευασία ρίγανης',
          text: 'Αναπνέουσα συσκευασία 50 γρ. για φρεσκάδα και άρωμα.',
        },
        packaging3: {
          alt: 'Μεγάλη συσκευασία ρίγανης',
          title: 'Μεγάλη συσκευασία ρίγανης',
          text: 'Για επαγγελματικές ανάγκες και μεγαλύτερες ποσότητες.',
        },
        packaging4: {
          alt: 'Επαγγελματική συσκευασία ρίγανης',
          title: 'Επαγγελματικές συσκευασίες ρίγανης',
          text: 'Ιδανικές για καταστήματα, horeca και μεγάλες παραγγελίες.',
        },
        packaging5: {
          alt: 'Αιθέριο έλαιο ρίγανης',
          title: 'Αιθέριο έλαιο ρίγανης',
          text: 'Συμπυκνωμένο προϊόν ρίγανης σε πρακτική συσκευασία 10 γρ., για εξειδικευμένη χρήση.',
        },
      },
      herb1: {
        eyebrow: 'Κατηγορία θυμαριού',
        marker: 'Θ',
        title: 'Θυμάρι',
        text: 'Αρωματικό και έντονο, με τις δικές του διαθέσιμες συσκευασίες για λιανική και επιλεγμένες επαγγελματικές χρήσεις.',
        packaging1: {
          alt: 'Γυάλινο βαζάκι θυμαριού',
          title: 'Γυάλινο βαζάκι θυμαριού',
          text: 'Ιδανικό για καθημερινή χρήση και εύκολη αποθήκευση στην κουζίνα.',
        },
        packaging2: {
          alt: 'Χάρτινη συσκευασία θυμαριού',
          title: 'Χάρτινη συσκευασία θυμαριού',
          text: 'Ελαφριά και πρακτική συσκευασία 30 γρ. που διατηρεί το άρωμα και τη φρεσκάδα.',
        },
      },
      herb2: {
        eyebrow: 'Κατηγορία χαμομηλιού',
        marker: 'Χ',
        title: 'Χαμομήλι',
        text: 'Ήπιο και ευωδιαστό, με ξεχωριστές συσκευασίες που ταιριάζουν τόσο σε καθημερινή χρήση όσο και σε προσεγμένη παρουσίαση.',
        packaging1: {
          alt: 'Γυάλινο βαζάκι χαμομηλιού',
          title: 'Γυάλινο βαζάκι χαμομηλιού',
          text: 'Κομψή επιλογή για το σπίτι, ιδανική για συχνή χρήση και προστασία του προϊόντος.',
        },
        packaging2: {
          alt: 'Χάρτινη συσκευασία χαμομηλιού',
          title: 'Χάρτινη συσκευασία χαμομηλιού',
          text: 'Πρακτική επιλογή 30 γρ. για καθημερινή κατανάλωση και εύκολη μεταφορά.',
        },
      },
      mountainTea: {
        title: 'Τσάι του βουνού',
        text: 'Αυτό το 100% φυσικό τσάι του βουνού (Σιδερίτης) συλλέγεται παραδοσιακά και αποξηραίνεται φυσικά στον αέρα, διατηρώντας όλη του τη φρεσκάδα και τα ευεργετικά του συστατικά. Ιδανικό για την ενίσχυση του ανοσοποιητικού, την πέψη, την αντιμετώπιση των συμπτωμάτων του κρυολογήματος και τη χαλάρωση μετά από μια έντονη ημέρα.',
        packaging1: {
          alt: 'Μπουκέτο τσαγιού του βουνού',
          title: 'Μπουκέτο τσαγιού του βουνού',
          text: 'Πρακτική συσκευασία 40 γρ. που προστατεύει το προϊόν και διατηρεί το φυσικό του άρωμα.',
        },
      },
      note: 'Για τιμές χονδρικής, επικοινωνήστε μαζί μας.',
    },
    delivery: {
      title: 'Παράδοση',
      body:
        'Τα προϊόντα μας παραδίδονται στο χώρο σας αυτοπροσώπως μέσα σε 1-3 εργάσιμες ημέρες.',
    },
    contact: {
      title: 'Επικοινωνία',
      address: 'Άγιος Πρόδρομος, Χαλκιδικής',
    },
    toggle: 'EN',
    toggleAria: 'Switch to English',
  },
  en: {
    meta: {
      title: 'Bioregano | Product Catalog',
      description:
        'Bioregano from Agios Prodromos, Chalkidiki. Natural, organic, aromatic oregano.',
      keywords:
        'Bioregano,oregano, Workshop, Organic farming, Chalkidiki, Greek products',
    },
    brand: 'bioregano',
    nav: {
      hero: 'Home',
      intro: 'Intro',
      products: 'Products',
      delivery: 'Delivery',
      contact: 'Contact',
    },
    hero: {
      title: 'We cultivate the Greek land with care',
      cta: 'Learn more',
    },
    intro: {
      title: 'Introduction',
      body:
        'My name is Makavou Magdalini and I am a small-scale producer of organic aromatic herbs from Agios Prodromos, Chalkidiki. I focus on cultivating and producing high-quality oregano, thyme, chamomile, and mountain tea, 100% natural and organic, harvested with care to preserve their aroma and beneficial properties.',
    },
    products: {
      title: 'Products',
      body:
        'We carefully select and package oregano, thyme, chamomile, and mountain tea, preserving their aroma, flavor, and beneficial properties. They are available in different packaging options and quantities to meet every need.',
      newLabel: 'New',
      categoryEyebrow: 'New category',
      categoryTitle: 'Thyme & chamomile',
      categoryBody:
        'We are adding one more aromatic herb category with carefully selected thyme and chamomile, suitable for cooking, herbal infusions, and everyday use.',
      oregano: {
        eyebrow: 'Oregano category',
        marker: 'O',
        title: 'Oregano',
        text: 'Our core category, available in different packaging options for everyday use, retail shelves, and professional needs.',
        packaging1: {
          alt: 'Oregano glass jar',
          title: 'Oregano glass jar',
          text: 'Ideal for everyday use and storage, in a 50 gr. package.',
        },
        packaging2: {
          alt: 'Oregano paper pouch',
          title: 'Oregano paper pouch',
          text: 'Breathable 50 gr. packaging that keeps it fresh.',
        },
        packaging3: {
          alt: 'Large oregano pack',
          title: 'Large oregano pack',
          text: 'For professional use and larger quantities.',
        },
        packaging4: {
          alt: 'Professional oregano packs',
          title: 'Professional oregano packs',
          text: 'Ideal for shops, horeca, and bulk orders.',
        },
        packaging5: {
          alt: 'Oregano essential oil',
          title: 'Oregano essential oil',
          text: 'A concentrated oregano product in a practical 10 gr. package for specialized use.',
        },
      },
      herb1: {
        eyebrow: 'Thyme category',
        marker: 'T',
        title: 'Thyme',
        text: 'Bold and aromatic, with its own packaging options for retail use and selected professional needs.',
        packaging1: {
          alt: 'Thyme glass jar',
          title: 'Thyme glass jar',
          text: 'Ideal for everyday use and easy kitchen storage.',
        },
        packaging2: {
          alt: 'Thyme paper pouch',
          title: 'Thyme paper pouch',
          text: 'A practical 30 gr. pack that helps preserve aroma and freshness.',
        },
      },
      herb2: {
        eyebrow: 'Chamomile category',
        marker: 'C',
        title: 'Chamomile',
        text: 'Gentle and fragrant, with separate packaging options suited to both everyday use and a refined presentation.',
        packaging1: {
          alt: 'Chamomile glass jar',
          title: 'Chamomile glass jar',
          text: 'A refined home option for frequent use and dependable product protection.',
        },
        packaging2: {
          alt: 'Chamomile paper pouch',
          title: 'Chamomile paper pouch',
          text: 'A practical 30 gr. choice that is easy to store and carry every day.',
        },
      },
      mountainTea: {
        title: 'Mountain tea',
        text: 'This 100% natural mountain tea (Sideritis) is traditionally harvested and naturally air-dried, preserving all its freshness and beneficial properties. It is ideal for supporting the immune system, digestion, easing cold symptoms, and helping you relax after a demanding day.',
        packaging1: {
          alt: 'Mountain tea bouquet',
          title: 'Mountain tea bouquet',
          text: 'A practical 40 gr. package that helps protect the product and preserve its natural aroma.',
        },
      },
      note: 'For wholesale prices, please contact us.',
    },
    delivery: {
      title: 'Delivery',
      body:
        'Our products are delivered to your location in person within 1–3 business days.',
    },
    contact: {
      title: 'Contact',
      address: 'Agios Prodromos, Chalkidiki',
    },
    toggle: 'GR',
    toggleAria: 'Switch to Greek',
  },
};

export default translations;
